import React from 'react';
import { BeatLoader } from 'react-spinners';

export const StemiBeatLoader = (props: any) => {
  return (
    <BeatLoader {...props} size={20} color="var(--chakra-colors-blue-600)" />
  );
};

export const Loader = (props: any) => {
  return <StemiBeatLoader />;
};

export default Loader;
